import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import Footer from "../footer";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Studentaddfrom from "./studentaddfrom";
import FollowUpForm from "./Followupdata";
import { DeleteMarketingStudent, MarketingStudentList, excelimport, CreateMarketingSchool, GetMarketingSchool } from "../../../api/MarketinService";
import Swal from "sweetalert2";
import { closeModal, ToastMain ,SweetAlertShow} from "../../master/Master";
// import { ToastMain } from "../Master";
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver'
import { getSessions } from "../../../api/SessionsService";
import DownloadExcel from "../../master/DownloadExcel";
import { counselor } from "../../../api/Calling";
const SourceAssign = () => {
  const hasAccess = usePrivateLink();

  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [student, setStudent] = useState([]);
  const location = useLocation();
  const [search, setSearch] = useState('');
  const [session, setSession] = useState('');
  const [Selectedsession, setSelectedSession] = useState('');
  const [area, setArea] = useState('');
  const [source, setSource] = useState('');
  const [Selectedsource, setSelectedSource] = useState('');
  const [HostelId, setHostelId] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [sessionId, setSessionId] = useState('');
  const [sourceId, setSourceId] = useState('');
  const [file, setFile] = useState(null);
  const [responseMsg, setResponseMsg] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [counse, setcounse] = useState([]);


  const getSession = async () => {
    try {
      const response = await getSessions();
      if (response.data.status) {
        // console.log("session fetched", response.data);
        setSession(response?.data);
        setSessions(response?.data)
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'something went wrong'
        // })
        SweetAlertShow('info','Warning', response?.data?.message)
      }
    } catch (err) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: err?.response?.data?.message || 'something went wrong'
      // })

      SweetAlertShow('error','Error', err?.response?.data?.message ?? err?.message)
    }
  };


  const fetchStudent = async () => {
    let addUrl = `&session=${Selectedsession}&search=${search}&area=${area}&source_id=${Selectedsource}&page=${page}`
    setLoading(true);
    try {
      const response = await MarketingStudentList(addUrl);
      if (response.data.status) {
        setStudent(response?.data?.data);
      } else {
        setError("Failed to fetch courses.");
        // ToastMain.fire({
        //   icon: "info",
        //   title: response?.data?.message || 'something went wrong',

        // });
SweetAlertShow('info','Warning',response?.data?.message)

      }
    } catch (err) {
      // ToastMain.fire({
      //   icon: 'error',
      //   title: err?.response?.message || 'something went wrong'
      // })

      SweetAlertShow('error','Error',err?.response?.message ?? err?.message)
    } finally {
      setLoading(false);
    }
  };

  const deleteStudent = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action will permanently delete ",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await DeleteMarketingStudent(id);
          console.log("student deleted", response.data);
          fetchStudent()

          // ToastMain.fire({
          //   icon: "success",
          //   title: "delete successfully!",
          // });

          SweetAlertShow('success','Successfully',response?.data?.message)

        } catch (error) {
          // ToastMain.fire({
          //   icon: 'error',
          //   title: error?.response?.data?.message || 'something went wrong'
          // })

          SweetAlertShow('error','Error',error?.response?.data?.message  ?? error?.message)
        }
      }
    });
  };

  useEffect(() => {
    fetchStudent();
  }, [Selectedsession, search, Selectedsource, area, page])

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData(e.target);
    formData.append('file', file);

    try {
      const res = await excelimport(formData);
      console.log("Excel import response:", res.data);

      if (res.data) {
        ToastMain.fire({
          icon: "success",
          title: "upload Successfully!",
        }).then(() => {
          closeModal("statusChange");
          fetchStudent();
        });

      } else {
        // ToastMain.fire({
        //   icon: "info",
        //   title: res?.data?.message || "Something Went Wrong!",
        // });

        SweetAlertShow('info','Warning', res?.data?.message )
      }
    } catch (error) {
      // ToastMain.fire({
      //   icon: "error",
      //   title:
      //     error?.response?.data?.message ||
      //     error?.response?.message ||
      //     "Something Went Wrong!",
      // });

      SweetAlertShow('error','Error', error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    getSession();
  }, []);

  const handleDummyDownload = () => {
    // Dummy data
    const data = [
      ["Name", "Father's Name", "Mobile", "Alternate No", "State", "District", "Block", "Village", "Tehsil", "Address", "Education Level", "Description"],
      ["seema", "Ram", "1234567890", "9876543210", "Rajasthan", "jaipur", "amber", "chomu", "chomu", "House no.14", "12th Pass", "okkk"],
    ];

    // Create workbook and worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Students");

    // Convert workbook to blob
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });

    // Download using FileSaver
    saveAs(fileData, 'Student-Template.xlsx');
  };




  useEffect(() => {

    getSource();
  }, []);

  const getSource = async () => {
    try {
      const response = await GetMarketingSchool();
      console.log("Source List:", response.data);
      if (response?.data) {
        setSource(response?.data);
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'Something went wrong',
        // });

        SweetAlertShow('info','Warning', response?.data?.message )
      }
    } catch (error) {
      console.error("API Error:", error);
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong',
      // });

      SweetAlertShow('error','Error',error?.response?.data?.message ?? error?.message)
    }
  };
const handleDownloadAll = async () => {
    try {
      setLoading(true);
      let allData = [];

      // Fetch page 1 to get last_page info
      const firstResponse = await MarketingStudentList("?page=1");
      const lastPage = firstResponse?.data?.data?.last_page || 1;

      // Loop through all pages
      for (let page = 1; page <= lastPage; page++) {
        const response = await MarketingStudentList(`page=${page}`);
        const records = response?.data?.data?.data || [];
        allData.push(...records);
      }

      if (allData.length === 0) {
        alert("No data to export!");
        return;
      }

      // Group by district
      const grouped = allData.reduce((acc, curr) => {
        const district = curr.district || "Unknown"; // no curr.student
        if (!acc[district]) acc[district] = [];
        acc[district].push(curr);
        return acc;
      }, {});

      // Flatten grouped data, sort districts A-Z, and names within district
      const finalData = Object.keys(grouped)
        .sort()
        .flatMap((district) => {
          const studentsInDistrict = grouped[district];
          studentsInDistrict.sort((a, b) => {
            const nameA = (a.name || "").toUpperCase();
            const nameB = (b.name || "").toUpperCase();
            return nameA.localeCompare(nameB);
          });
          return studentsInDistrict;
        });

      // Map to Excel structure
      const mappedData = finalData.map((s, index) => ({
        SN: index + 1,
        "Student Name": s.name || "",
        "Father Name": s.father_name || "",
        mobile: s.phone || "",
        district: s.district || "",
        village: s.village || "",
        pincode: s.zipcode || "",
        state: s.state || "",
        education: s.education || "N/A",
        school: s.school || "N/A",
      }));

      DownloadExcel(mappedData, Object.keys(mappedData[0]), "Student List");

      alert(`Exported ${allData.length} records successfully!`);
    } catch (error) {
      console.error(error);
      alert(`Error exporting: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const getcounselor = async () => {
    setLoading(true)
    try {
      const response = await counselor();
      console.log("Source List:", response.data);
      if (response?.data) {
        setcounse(response?.data?.data );
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: response?.data?.message || 'Something went wrong',
        // });
        SweetAlertShow('info','Warning',response?.data?.message )
      }
    } catch (error) {
      console.error("API Error:", error);
      // ToastMain.fire({
      //   icon: 'error',
      //   title: error?.response?.data?.message || 'something went wrong',
      // });

      SweetAlertShow('error','Error', error?.response?.data?.message ?? error?.message)
    } finally {
      setLoading(false)
    }
  };

  useEffect(() => {
    getcounselor()
  }, [])

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-4">
                {hasAccess('/marketing/all-students') && (
                  <Link to={"/marketing/all-students"}>
                    <button
                      className="btn btn-label-primary me-2 mb-4 btn-sm"
                    >
                      <span className="text">Students</span>
                    </button></Link>
                )}
                {hasAccess('/marketing') && (
                  <Link to={"/marketing"}>
                    <button
                      className="btn btn-label-primary me-2 mb-4 btn-sm "
                    >
                      <span className="text"> Source</span>
                    </button></Link>
                )}

                {hasAccess('/marketing') && (
                  <Link to={"/marketing/source/assign"}>
                    <button
                      className="btn btn-primary me-2 mb-4 btn-sm "
                    >
                      <span className="text">Source Assign</span>
                    </button></Link>
                )}


                {/* Page Header */}
                <div className="card py-4 px-3 mb-4 shadow-sm">
                  <h4 className="text-primary">Source Assign</h4>
                  <div className="">
                    <div className="row">
                      {/* {JSON.stringify(counse)} */}
                      <div className="col-md-3 form-floating form-floating-outline">
                        <select
                          name="counselor_id"
                          className="form-select"
                          defaultValue=""
                        >
                          <option value="" disabled>
                            -- Select Counselor --
                          </option>
                         {counse?.map((item, index)=>(

                           <option key={item.id} value={item?.id}>{item?.name}</option>
                         )
                         )}
                        </select>
                        <label>Select Counselor</label>
                      </div>

                      <div className="col-md-3 mb-4 form-floating form-floating-outline">
                        <select className="form-select" name="source_id" value={Selectedsource} onChange={(e) => setSelectedSource(e.target.value)}>
                          <option value="">Select Source</option>
                          {source?.data?.map((sch, index) => (
                            <option key={sch.id} value={sch.id}>
                              {sch.source_name}
                            </option>
                          ))}
                        </select>
                        <label>Source Name</label>
                      </div>
                    </div>
                  </div>


                  {/* Table Section */}
                  <div className="table-responsive">

                    <div className="container mt-5 mb-5">

                    </div>
                    <table className="table  text-center align-middle table-sm">
                      <thead className="table-primary">
                        <tr>
                          <th>#</th>
                          <th>Name</th>
                          <th>Mobile</th>
                          <th>Father's Name</th>
                          <th>Address</th>
                          <th>Education Level</th>
                          <th>Note</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {student?.data?.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center">No Data Found</td>
                          </tr>
                        ) : (
                          student?.data?.map((std, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{std.name || 'N/A'}</td>
                              <td>{std.mobile || 'N/A'}</td>
                              <td>{std.fathers_name || 'N/A'}</td>
                              <td>{std.address || 'N/A'}</td>
                              <td>{std.edu_level || 'N/A'}</td>
                              <td>{std.description || 'N/A'}</td>
                              <td>{std.status === '1' ? 'Active' : 'Inactive'}</td>
                              <td>

                                {/* <li>
                                                              <Link to={"/marketing/all-students"}>
                                                                <button className="dropdown-item">
                                                                  <i className="bi bi-eye-fill me-2 text-success"></i> View
                                                                </button>
                                                              </Link>
                                                            </li> */}

                                {hasAccess('/marketing/update_student') && (
                                  <Link className="btn btn-outline-primary btn-sm" to={'/marketing/update_student'} state={{ id: std }} >
                                    <i className="bi bi-pencil-square me-2 text-primary"></i> Edit
                                  </Link>
                                )}


                                {hasAccess('/marketing/student/delete') && (
                                  <button className=" btn btn-sm btn-outline-danger ms-2 text-danger" onClick={() => deleteStudent(std.id)}>
                                    <i className="bi bi-trash-fill me-2 text-danger"></i> Delete
                                  </button>
                                )}


                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                    <nav aria-label="Page navigation" className="mt-10">
                      <p>
                        Showing {student?.from} to {student?.to} of{" "}
                        {student?.total} entries
                      </p>
                      <ul className="pagination pagination-sm">
                        {student?.links?.map((btn, i) => (
                          <li
                            className={`page-item  ${btn?.active && "active"
                              }  ${btn?.url ? "" : "disabled"} `}
                          >
                            <button
                              className="page-link waves-effect"
                              onClick={() => {
                                if (student?.links?.length === i + 1) {
                                  btn?.url &&
                                    setPage(student?.current_page + 1);
                                } else if (i === 0) {
                                  btn?.url &&
                                    setPage(student?.current_page - 1);
                                } else {
                                  setPage(btn.label);
                                }
                              }}
                            >
                              {student?.links?.length == i + 1 ? (
                                <i className="icon-base ri ri-skip-forward-mini-line icon-20px" />
                              ) : i == 0 ? (
                                <i className="icon-base ri ri-skip-back-mini-line icon-20px" />
                              ) : (
                                btn?.label
                              )}
                            </button>
                          </li>
                        ))}
                      </ul>
                    </nav>
                    {/* Table Footer */}
                    <div className="d-flex justify-content-between align-items-center">
                      {/* <small className="text-muted">
                        Showing {student?.from} to {student?.to} of {student?.total} entries
                      </small> */}
                      {/* <div className="mt-3">
                        <button className="btn btn-outline-secondary btn-sm me-2">
                          Previous
                        </button>
                        <button className="btn btn-outline-secondary btn-sm">
                          Next
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>

                <Footer />
                <div className="content-backdrop fade"></div>
              </div>
            </div>
          </div>
          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>
      <div
        className="modal fade modal-xl"
        id="ADDNewstudent"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4
                className="text-primary modal-title mx-4"
                id="exampleModalLabel"
              >
                Add New Student
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <Studentaddfrom />
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade modal-xl"
        id="editNewstudent"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="text-primary modal-title " id="exampleModalLabel">
                Update Student
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body">
              <div className="container">
                <div className=" p-4">
                  <form>
                    <div className="row mb-3">
                      <div className="col-md-12">
                        <label className="form-label fw-bold">
                          School Name
                        </label>
                        <select className="form-select">
                          <option>Select School</option>
                        </select>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">
                          Student Name
                        </label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">
                          Father's Name
                        </label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">mobile No</label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">
                          Other Mobile
                        </label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">
                          Education Level
                        </label>
                        <select className="form-select">
                          <option>12th Pass</option>
                          <option>10th Pass</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Village</label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                    </div>

                    <div className="row mb-3">
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Tehsil</label>
                        <textarea className="form-control" rows={2}></textarea>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">State</label>
                        <select className="form-select">
                          <option>Select State</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">District</label>
                        <select className="form-select">
                          <option>Select District</option>
                        </select>
                      </div>
                      <div className="col-md-6">
                        <label className="form-label fw-bold">Block</label>
                        <select className="form-select">
                          <option>Select Block</option>
                        </select>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade modal-xl"
        id="FollowupFrom"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Student Follow Up
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body"><FollowUpForm /></div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="button" className="btn btn-primary">
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>


      {showModal && (
        <div className="modal show fade d-block" id="statusChange" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <form onSubmit={handleSubmit}>
                <div className="modal-header">
                  <h5 className="modal-title">Import Students via Excel</h5>
                  <button type="button" className="btn-close" onClick={() => setShowModal(false)}></button>
                </div>

                <div className="modal-body">
                  {responseMsg && (
                    <div className={`alert alert-${responseMsg.type === 'error' ? 'danger' : 'success'}`}>
                      {responseMsg.text}
                    </div>
                  )}

                  {/* Download Template Button */}
                  <div className="mb-3">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-sm"
                      onClick={handleDummyDownload}
                    >
                      <i className="bi bi-cloud-arrow-down ri-20px"></i>
                      Download Sample Excel
                    </button>
                  </div>

                  <div className="form-floating form-floating-outline mb-4">
                    <select

                      className="form-select"
                      id="session_id"
                      name="session_id"

                    >
                      <option value="">Select Session</option>
                      {session?.data?.map((session) => (
                        <option key={session.id} value={session.id} selected={session.status === '1'}>
                          {session.session} :   {session.status === '1' ? 'Active' : 'Inactive'}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="course">Select session</label>
                  </div>

                  <div className="mb-3">
                    <div className="form-floating form-floating-outline mb-2">
                      <select
                        name="source_id"
                        className="form-select"

                        defaultValue=""
                      >
                        <option value="" disabled>Select Source</option>
                        {source?.data?.map((source, index) => (
                          <option key={index} value={source.id}>
                            {source.source_name}
                          </option>
                        ))}
                      </select>


                      <label>Source Name</label>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label>Upload Excel File</label>
                    <input
                      type="file"
                      className="form-control"
                      accept=".xlsx,.xls"
                      onChange={(e) => setFile(e.target.files[0])}
                      required
                    />
                  </div>
                </div>

                <div className="modal-footer">
                  <button type="submit" className="btn btn-success">
                    Upload
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={() => setShowModal(false)}>
                    Close
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}






    </>
  );
};

export default SourceAssign;
